import styled from 'styled-components'

export const Wrapper = styled.div`
  text-align: right;
  padding-top: 24px;
  button {
    height: 40px;
    margin-left: 8px;
    border-radius: 8px;
    padding: 0 12px;
    color: #4c4c4c !important;
    background-color: #f0f0f0;
    &:hover {
      background-color: #e8e8e8;
    }
    border: none;
    font-weight: 700;
  }
  div {
    float: right;
    button {
      color: white !important;
      background-color: #0085ff !important;
      &:hover {
        background-color: #0069f2 !important;
      }
      &:disabled {
        opacity: 0.48;
      }
    }
  }
`
